export default "__VITE_ASSET__BJYnIzG3__"